import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { getAllVideos } from '../services/videoService';
import VideoCard from './VideoCard';
import './VideoShowcase.css';
import '../pages/home/components/HomeSections.css';

const VideoShowcase = ({ limit = 6 }) => {
  const [videos, setVideos] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;

    const loadFeaturedVideos = async () => {
      try {
        // Fetch extra so unpublished videos don't leave the row short.
        const response = await getAllVideos(1, limit * 2);
        if (!cancelled && response.success) {
          const publishedVideos = response.data.items.filter(v => v.isPublished);
          setVideos(publishedVideos.slice(0, limit));
        }
      } catch (error) {
        console.error('Error loading videos:', error);
      }
    };

    loadFeaturedVideos();
    return () => {
      cancelled = true;
    };
  }, [limit]);

  // Nothing renders until there are published videos to show.
  if (videos.length === 0) {
    return null;
  }

  return (
    <section
      className="hs hs--tint video-showcase-section"
      aria-labelledby="hs-videos-title"
    >
      <div className="hs__inner">
        <div className="hs__head">
          <div>
            <h2 id="hs-videos-title" className="hs__title">
              See the projects running
            </h2>
            <p className="hs__sub">
              Walkthroughs and demos of projects from the catalog.
            </p>
          </div>
          <Link className="hs__link" to="/videos">
            All videos
            <ArrowRight aria-hidden="true" />
          </Link>
        </div>

        <div className="row g-24">
          {videos.map(video => (
            <div
              className="col col-24 sm-12 lg-8"
              key={video.id || video.videoId}
            >
              {/* Opens the demo on the Videos page, next to the price and Buy button. */}
              <VideoCard
                video={video}
                onClick={() => navigate(`/videos?v=${encodeURIComponent(video.id)}`)}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideoShowcase;
